export default "__VITE_ASSET__B5HwKeo6__"